import React from 'react';
import { Props } from './types';
import StatusMovimentacao from './components/statusMovimentacao';
import StatusSolicitacaoRetorno from './components/statussolicitacaoRetorno';
import StatusEntregaNoCd from './components/statusEntrega';
import StatusOrdemCarga from './components/statusOrdemCarga';
import StatusAgendamentos from './components/statusAgendamentos';
import StatusAtendimento from './components/statusAtendimentos';
import StatusTracking from './components/statusTracking';

const Status: React.FC<Props> = ({ acronym }) => {
  switch (window.location.pathname) {
    case '/dashboard/movimentacoes':
      return <StatusMovimentacao acronym={acronym} />;
    case '/dashboard/solicitacoesderetorno':
      return <StatusSolicitacaoRetorno acronym={acronym} />;
    case '/dashboard/entregaNocd':
      return <StatusEntregaNoCd acronym={acronym} />;
    case '/dashboard/ordemCarga':
      return <StatusOrdemCarga acronym={acronym} />;
    case '/dashboard/agendamentos':
      return <StatusAgendamentos acronym={acronym} />;
    case '/dashboard/atendimento':
      return <StatusAtendimento acronym={acronym} />;
    case '/dashboard/tracking':
      return <StatusTracking acronym={acronym} />;
    case '/dashboard/dash/sla':
      return <StatusAtendimento acronym={acronym} />;
    default:
      return <h1>Não identificado</h1>;
  }
};

export const orange: string = '#DD6C24';
export const blue: string = '#006CD4';
export const green: string = '#149E26';
export const cyan: string = '#00FFFF';
export const red: string = '#F5222D';
export const lemon: string = '#00ff00';
export const yellow: string = '#fcf375';

export default Status;
